import { actionTypes } from "../../actionTypes";

const initialState = { innerHtml: '', isLoading: true };

export const actionCreators = {
    getHtmlContent: (programmeId, action, formListPageNumber) => async (dispatch) => {

        await dispatch({ type: actionTypes.GET_SMPAC_HEADER });

        const url = `/SMPAC/PACHeader.aspx?programmeid=${programmeId}&action=${action}&progstatpage=${formListPageNumber}&formtype=NL`;

        await fetch(url, {
            credentials: 'same-origin'
        }).then(function (response) {
            return response.text();
        }).then(function (urlBody) {
            dispatch({ type: actionTypes.GET_SMPAC_HEADER_SUCCESS, innerHtml: urlBody });
        });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_SMPAC_HEADER:
            return {
                ...state,
                innerHtml: state.innerHtml,
                isLoading: true
            };
        case actionTypes.GET_SMPAC_HEADER_SUCCESS:
            return {
                ...state,
                innerHtml: action.innerHtml,
                isLoading: false
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/Controls/SMPACHeaderStore.js